export default "__VITE_ASSET__DmnWh1Do__"